import { getColDef } from '@/entities/columnDefinitions/libs/getColDef'
import { BusinessModelEnum } from '@/entities/user/models/BusinessModel'
import { ColourGridCell } from '@/shared/components/GridTable/GridCells/ColourGridCell'
import { useAppSelector } from '@/shared/store'
import { GridColDef } from '@mui/x-data-grid-premium'

export const useOpenOrdersColumnDefs = () => {
  const businessModel = useAppSelector((state) => state.user.businessModel)

  const columnDefs: (GridColDef | null)[] = []

  columnDefs.push(getColDef('orderNumber', 'order.orderNumber'))
  columnDefs.push(getColDef('weight', 'order.weight'))
  columnDefs.push(getColDef('volume', 'order.volume'))
  columnDefs.push(getColDef('orderQuantity', 'order.quantity'))
  columnDefs.push(getColDef(
    'timeWindow',
    'order.timeWindow',
    {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      valueGetter: (_, row) => row.order.timeWindows?.map((tw: { display: any }) => tw.display).join(', '),
    },
  ))
  columnDefs.push(getColDef('serviceTime', 'order.serviceTime'))
  columnDefs.push(getColDef('priority', 'order.priority'))
  columnDefs.push(getColDef('displayOrderAttributes', 'order.displayOrderAttributes'))
  columnDefs.push(getColDef('tripNo', 'order.tripNumber'))
  columnDefs.push(getColDef('consignmentNumber', 'order.consignmentNumber'))
  columnDefs.push(getColDef('description', 'order.description'))
  columnDefs.push(getColDef('driverNote', 'order.driverNote'))
  columnDefs.push(getColDef('deliveryInstruction', 'order.deliveryInstruction'))
  columnDefs.push(getColDef('comments', 'order.comment'))

  // Order Status
  columnDefs.push({
    field: 'statusTypeString',
    headerName: 'Status',
    width: 100,
    filterable: true,
    sortable: true,
    pinnable: true,
    type: 'string',
    renderCell: (params) => (<ColourGridCell {...params} />),
    valueGetter: (value, row) => ({
      text: value,
      cellStyle: row.statusCellStyle,
    }),
  })

  // Assignment Status
  columnDefs.push({
    field: 'assignedTo',
    headerName: 'Current Run',
    width: 180,
    filterable: true,
    sortable: true,
    pinnable: true,
    type: 'string',
  })
  columnDefs.push({
    field: 'newLocation',
    headerName: 'New Assignment',
    width: 180,
    filterable: false,
    sortable: false,
    pinnable: true,
    type: 'string',
    renderCell: (params) => (<ColourGridCell {...params} />),
    valueGetter: (value, row) => ({
      text: value,
      cellStyle: row.newLocationCellStyle,
    }),
  })

  if (businessModel === BusinessModelEnum.Depot) {
    columnDefs.push(getColDef('customerAddress', 'order.location.displayAddress'))
    columnDefs.push(getColDef('customerSuburb', 'order.location.suburb'))
    columnDefs.push(getColDef('customerState', 'order.location.state'))
    columnDefs.push(getColDef('customerPostcode', 'order.location.postcode'))

    columnDefs.push(getColDef('customerNumber', 'order.location.externalId'))
    columnDefs.push(getColDef('customerName', 'order.location.name'))

    columnDefs.push(getColDef('depotCode', 'order.depot.externalId'))
    columnDefs.push(getColDef('depotName', 'order.depot.name'))
  }

  if (businessModel === BusinessModelEnum.Courier) {
    columnDefs.push(getColDef('pickupName', 'order.fromLocation.name'))
    columnDefs.push(getColDef('pickupExternalId', 'order.fromLocation.externalId'))
    columnDefs.push(getColDef('pickupAddress', 'order.fromLocation.displayAddress'))
    columnDefs.push(getColDef('pickupSuburb', 'order.fromLocation.suburb'))
    columnDefs.push(getColDef('pickupState', 'order.fromLocation.state'))
    columnDefs.push(getColDef('pickupPostcode', 'order.fromLocation.postcode'))
    columnDefs.push(getColDef('pickupServiceTime', 'order.serviceTimePickup'))
    columnDefs.push(getColDef('pickupInstruction', 'order.pickupInstruction'))

    columnDefs.push(getColDef('deliveryName', 'order.toLocation.name'))
    columnDefs.push(getColDef('deliveryExternalId', 'order.toLocation.externalId'))
    columnDefs.push(getColDef('deliveryAddress', 'order.toLocation.displayAddress'))
    columnDefs.push(getColDef('deliverySuburb', 'order.toLocation.suburb'))
    columnDefs.push(getColDef('deliveryState', 'order.toLocation.state'))
    columnDefs.push(getColDef('deliveryPostcode', 'order.toLocation.postcode'))
    columnDefs.push(getColDef('deliveryServiceTime', 'order.serviceTimeDelivery'))
  }

  return columnDefs.filter(item => item !== null) as GridColDef[]
}